import type { OidcConfig } from "./config";

export class OidcUnavailableError extends Error {
  constructor() {
    super("Identity provider is unavailable");
    this.name = "OidcUnavailableError";
  }
}

export async function assertOidcProviderAvailable(
  config: OidcConfig,
  signal: AbortSignal,
): Promise<void> {
  try {
    await fetch(
      `${config.url}/realms/${encodeURIComponent(config.realm)}/.well-known/openid-configuration`,
      {
        method: "GET",
        mode: "no-cors",
        cache: "no-store",
        signal,
      },
    );
  } catch {
    throw new OidcUnavailableError();
  }
}